import Hashids from 'hashids'

const SALT = 'hato-dine-in-qr'
const MIN_LENGTH = 8

const hashids = new Hashids(SALT, MIN_LENGTH)

export default hashids
